import { Injectable, inject } from '@angular/core';
import { Database, ref, onValue } from '@angular/fire/database';
import { Observable, BehaviorSubject, catchError, of } from 'rxjs';
import { Theme } from '../models/theme.model';

@Injectable({
  providedIn: 'root'
})
export class FirebaseThemeService {
  private database = inject(Database);
  private themeSubject$ = new BehaviorSubject<Theme | null>(null);

  getTheme$(): Observable<Theme | null> {
    return this.themeSubject$.asObservable().pipe(
      catchError((error) => {
        return of(null);
      })
    );
  }

  /** Detach handle for the current theme listener. */
  private themeUnsubscribe: (() => void) | null = null;
  /** Unit the listener belongs to, so re-entering the same unit is a no-op. */
  private themeRouteName: string | null = null;

  /**
   * Called on every NavigationEnd, so without detaching the previous listener
   * each unit visited left one attached for the rest of the session.
   */
  initializeThemeListener(routeName: string): void {
    if (this.themeRouteName === routeName && this.themeUnsubscribe) {
      return;
    }
    this.themeUnsubscribe?.();
    this.themeUnsubscribe = null;
    this.themeRouteName = routeName;

    const themePath = `Clients/${routeName}/theme/catering`;
    const themeRef = ref(this.database, themePath);

    this.themeUnsubscribe = onValue(
      themeRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const firebaseData = snapshot.val();
          const firebaseTheme = firebaseData as Theme;

          this.themeSubject$.next(firebaseTheme);
        } else {
          this.themeSubject$.next(null);
        }
      },
      (error) => {
        this.themeSubject$.next(null);
      }
    );
  }

}

